import * as React from 'react';
import { Input } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const TextArea = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <Input.TextArea className={className} {...formItemSettings} />
    </FormItem>
  );
};

export default TextArea;
